let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9wN8W")).then(() => parcelRequire('8nyVz'));